import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface IorMatchGateHost {
  confirmIorMatchOrPass(): Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class IorMatchGateService {
  private host: IorMatchGateHost | null = null;

  public register(host: IorMatchGateHost): void {
    this.host = host;
  }

  public unregister(host: IorMatchGateHost): void {
    if (this.host === host) {
      this.host = null;
    }
  }

  public confirmIorMatchOrPass(): Observable<boolean> {
    return this.host ? this.host.confirmIorMatchOrPass() : of(true);
  }
}
